// This component is a copy, rename and extension of the library
// https://github.com/github/tab-container-element/releases/tag/v4.8.0

import { TabContainerElement } from './element';

export { TabContainerElement };
export default TabContainerElement;

export * from './define';
